import React from 'react';
import { Search } from 'lucide-react';

interface GlobalSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export default function GlobalSearch({ searchQuery, setSearchQuery }: GlobalSearchProps) {
  return (
    <div className="relative w-full max-w-sm">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
      <input
        type="text"
        placeholder="Search 440+ tools..."
        className="w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl pl-10 pr-4 py-2 text-sm focus:ring-2 focus:ring-brand"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>
  );
}
